import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonService, UserService } from '../../../../services/common';
import { AddressType, UserSubType } from '../../../../../appconfig';
import { SalesService } from '../../sales.service';

@Component({
  selector: 'app-client-details',
  templateUrl: './client-details.component.html',
  styleUrl: './client-details.component.scss'
})
export class ClientDetailsComponent implements OnInit, OnChanges {
  @Input() client: any;
  @Input() currentUnitSaleDetails: any;
  @Output() khasraClicked: EventEmitter<any> = new EventEmitter<any>();
  currentClientData: any;
  userProfileImageConfig: any;
  currentclientKhasras: any
  groupedKhasras: any;


  constructor(public commonService: CommonService, private userService: UserService, private saleservice: SalesService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {

    // Initialize client data or fetch from a service
    if (this.client?.id)
      this.getUserData();
  }

  /**
   * Fetches user data for the current client.
   * It retrieves the client's details and processes their addresses.
   * If the client has khasras, it fetches them as well.
   */
  getUserData() {
    this.userService.getFilterUser(null, null, null, this.client?.id).subscribe((res: any) => {
      this.currentClientData = null;
      if (res != null) {
        this.currentClientData = res?.result?.map((data: any) => {
          data.clientName = data?.nameInitial?.name + '.' + ' ' + data?.firstName + ' ' + data?.lastName;
          if (data?.addresses?.length > 0) {
            data?.addresses?.forEach((addr: any) => {
              const type = addr?.assressType?.name?.toLowerCase();

              if (type == (AddressType.Current.toString().toLowerCase())) {
                data.currentAddress = addr;
              } else if (AddressType.Permanent.toString().toLowerCase()) {
                data.permanentAddress = addr;
              } else if (AddressType.Firm.toString().toLowerCase()) {
                data.firmAddress = addr;
              }
              return data;
            })
          }
          return data;
        });

        if (Array.isArray(this.currentClientData) && this.currentClientData.length > 0) {
          this.currentClientData = this.currentClientData[0];
          var cur = this.currentUnitSaleDetails;
        }
        // this.getclientBookingAllotments(this.currentClientData);
      }
    });

    //Set config for client Profile Pic
    this.userProfileImageConfig = {
      userId: this.client?.id,
      allotmentId: this.currentUnitSaleDetails?.id,
    }
  }


  /**
   * Gets Booking/Allotments for the current client.
   * @param currentClientData - The data of the current client.
   */
  getclientBookingAllotments(currentClientData: any) {
    this.saleservice.filterAllotment(null, null, null, null, currentClientData?.id).subscribe(data => {
      // Step 1: Filter khasras where current client is part of it
      this.currentclientKhasras = data.filter((khasra: any) =>
        khasra.clients.some((client: any) => client?.id === currentClientData?.id)
      );

      this.groupedKhasras = [];

      // Step 2: Group khasras by landKhata and include client's individual payment
      this.currentclientKhasras.forEach((khasra: any) => {
        const khataId = khasra.landKhata?.id;
        if (!khataId) return;

        // Step 3: Get individual payment by current client from `amounts`
        const clientUserId = currentClientData?.id;
        const paymentByclient = khasra.amounts
          ?.filter((amt: any) => amt.account?.userId === clientUserId)
          ?.reduce((sum: number, amt: any) => sum + (parseFloat(amt.amountValue) || 0), 0);

        // Step 4: Check if group for landKhata already exists
        const existingGroup = this.groupedKhasras.find((group: any) => group?.landKhata?.id === khataId);

        // Step 5: Push khasra into group
        if (existingGroup) {
          existingGroup.khasra.push({ ...khasra, paymentToCurrentclient: paymentByclient });
        } else {
          this.groupedKhasras.push({
            landKhata: khasra.landKhata,
            khasra: [{ ...khasra, paymentToCurrentclient: paymentByclient }],
            totalArea: 0,
          });
        }
      });

      // Step 6: Calculate totalArea for each grouped khata
      this.groupedKhasras.forEach((group: any) => {
        group.totalArea = parseFloat(
          group.khasra.reduce((sum: number, k: any) => sum + (parseFloat(k?.area) || 0), 0).toFixed(2)
        );
      });
    });
  }

  /**
   * opens a modal to view khasra details.
   * @param currentKhasra current khasra whose details are to be viewed
   */
  openKhasraModal(currentKhasra: any) {
    this.khasraClicked.emit({ khasra: currentKhasra });
  }
}
